export enum EventType {
  LOGOUT = 'logout',
}
